export const css = {
	root: 'psU3Qj8p',
	' _key': 'progress-chart/progress-chart'
};

export default css;
